import { downloadBlob } from '~/libs/downloadBlob'

/** UTF-8 BOM。 Excel で CSV を開いたときの文字化けを防ぐために先頭へ付与する。 */
const UTF8_BOM = '﻿'

/**
 * CSV 文字列をブラウザのファイルダウンロードとして保存する副作用ヘルパー。
 *
 * CSV 本文の組み立て (列・整形) は各 model の pure な builder が担い、 本関数は Blob 生成
 * → 保存 (`downloadBlob`) の副作用のみに責務を絞る。
 */
export const downloadCsv = (filename: string, csv: string): void => {
  downloadBlob(
    filename,
    new Blob([`${UTF8_BOM}${csv}`], { type: 'text/csv;charset=utf-8;' }),
  )
}
